import { render, staticRenderFns } from "./SalesPayments.vue?vue&type=template&id=485660ed&scoped=true"
import script from "./SalesPayments.vue?vue&type=script&lang=js"
export * from "./SalesPayments.vue?vue&type=script&lang=js"
import style0 from "./SalesPayments.vue?vue&type=style&index=0&id=485660ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485660ed",
  null
  
)

export default component.exports